import { render, staticRenderFns } from "./setPower.vue?vue&type=template&id=493e655a&scoped=true"
import script from "./setPower.vue?vue&type=script&lang=js"
export * from "./setPower.vue?vue&type=script&lang=js"
import style0 from "./setPower.vue?vue&type=style&index=0&id=493e655a&prod&lang=scss"
import style1 from "./setPower.vue?vue&type=style&index=1&id=493e655a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493e655a",
  null
  
)

export default component.exports